const MS_BASE_URL = process.env.REACT_APP_CHATBOT_BASE_API;

export const API_CONFIG = {
  /* MS APIs Start */
  EMAIL_API: `${MS_BASE_URL}/dcchatbotemail/v2/email`,
  ANALYTICS_API: `${MS_BASE_URL}/dcchatbotemail/v2/analytics`,
  POST_CALL_API: `${MS_BASE_URL}/dclexchatbotv2/v2/postlexcontent`,
  POST_LEX_ATTACHMENTS_API: `${MS_BASE_URL}/dclexchatbotv2/v2/attachments`,
  FILE_UPLOAD_LESS_THAN_4_MB: `${MS_BASE_URL}/dcwebform/v2/4mbUpload`,
  DELETE_SESSION_API: `${MS_BASE_URL}/dclexchatbotv2/v2/sessiondelete`,
  TOKEN_SERVICE_V2_URL: `${MS_BASE_URL}/dcssp-pega/ssp/v2/auth/token`,
  TOKEN_SERVICE_V3_URL: `${MS_BASE_URL}/dcssp-pega/ssp/v3/auth/token`,
  UNAUTHENTICATE_INITIATE_UI_URL: `${MS_BASE_URL}/ob-idmapi/light/authentication/SSP/v2/unauthenticated/initiateui`,
  TOKEN_SERVICE_URL: `${MS_BASE_URL}/dcconnect/auth/token`,
  BALCANCEL_FORM_URL: `${MS_BASE_URL}/dcwebform/balcancel`,
  CONNECT_AUTH_URL: `${MS_BASE_URL}/dcconnect/v2/websocket/authToken`,
  DOWNLOAD_FILE_CALL_API: `${MS_BASE_URL}/dcconnect/v2/connection/attachmentId`,
  AGENT_FEEDBACK_CALL_API: `${MS_BASE_URL}/dcchatbotemail/v2/feedback`,
  USER_FORM_URL: `${MS_BASE_URL}/dclexchatbotv2/v2/liveagent`,
  GET_COUNTRIES_LIST: `${MS_BASE_URL}/dclexchatbotv2/v2/countrylist`,
  FILE_UPLOAD: `${MS_BASE_URL}/dcwebform/v2/upload`,
  FEEDBACK_SUBMIT_API: `${MS_BASE_URL}/dcssp-pega/v2/feedback`,
  SSP_TOKEN: `${MS_BASE_URL}/dcssp-pega/ssp/v2/auth/token`,

  /* MS APIs End */

  /* Images URLs Start */

  CHATBOT_ICON: `/sspImageReferences/widgetIcon.png`,
  CHATBOT_ICON_URL: `/sspImageReferences/Chatbot_-35x35.png`,
  CHATBOT_LOGO_URL: `/sspImageReferences/Chatbot_-70x70.png`,

  /* Images URLs End */
};
